import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";

export default function ProcessingOverlay({ children, toggleLoading }) {
  const [textUpdated, setTextUpdated] = useState("Processing, please wait...");
  let [counter, setCounter] = useState(0);

  useEffect(() => {
    if (!toggleLoading) setCounter(0);
    let loadingInterval = setInterval(() => {
      if (toggleLoading) setCounter((c) => c++);
    }, 1000);
    return () => {
      clearInterval(loadingInterval);
    };
  }, [toggleLoading]);

  useEffect(() => {
    if (counter > 19) {
      setTextUpdated(
        "Still processing, please check your internet connection..."
      );
    } else {
      setTextUpdated("Processing, please wait...");
    }
  }, [counter]);

  return (
    <LoadingOverlay active={toggleLoading} spinner text={textUpdated}>
      {children}
    </LoadingOverlay>
  );
}
